import { defineNuxtPlugin } from "#app";
import { Adsense } from "vue3-google-adsense";

// 只用 Nuxt3/Vue3 的注册方式，去掉 Vue 2 的写法，避免 import Vue 报错
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("Adsense", Adsense);
});
